<template>
  <div>
    <div style="font-weight: bold; color: #5E6775; font-size: 16px;">AI Data Entry Assistant</div>
    <div style="height:20px;">&nbsp;</div>
    Related Keywords
    <div>
      <kendo-datasource
        :ref="'keywordDataSource'"
        :data="keywordDataSource.data">
      </kendo-datasource>
      <kendo-grid
        :ref="'keywordGrid'"
        :data-source-ref="'keywordDataSource'"
        :editable="'inline'"
        :selectable="selectable"
        style="width: calc(100% - 0px);"
        :columns="keywordColumns">
      </kendo-grid>
    </div>
    <div style="height:20px;">&nbsp;</div>
    <div style="display:flex; flex-direction: row;">
      <input type="checkbox">
      <div>Show only the above Keywords</div>
    </div>
    <div style="height:20px;">&nbsp;</div>
    Suggested Natural Language Question (NLQ)
    <div style="display:flex; flex-direction: row;">
      <input type="radio" name="nlqOptions">
      <textarea :rows="2" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;" disabled="'disabled">What is the Study Initiation?</textarea>
    </div>
    <div style="height:20px;">&nbsp;</div>
    Edited Natural Language Question (NLQ)
    <div style="display:flex; flex-direction: row;">
      <input type="radio" name="nlqOptions">
      <textarea :rows="2" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;">What is the Study Initiation?</textarea>
    </div>
    <div style="display:flex; justify-content: flex-end;">
      <button class="k-button" @click="askQuestionAction">Ask Question</button>
      <button class="k-button" @click="cancelAction">Cancel</button>
    </div>
    <div style="display:flex; flex-direction: row;">
      <h1>Potential Answers:</h1>
    </div>
    <div v-if="askQuestion">
      Match 1 - Abstract (60% success)
      <div class="answer">
        Objective: To evaluate the long-term safety and tolerability of ubrogepant for the acute treatment of migraine. Background(s): Ubrogepant is an oral, calcitonin gene-related receptor antagonist in development for the acute treatment of migraine. The efficacy of ubrogepant was demonstrated in 2 phase 3 trials in which a significant improvement was observed in migraine headache pain, migraine-associated symptoms, and ability to function.
        <!-- <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;"></textarea> -->
      </div>
      <div style="height:20px;">&nbsp;</div>
      Match 2 - File name: S01_COH_2025_TALQUETAMA(45332).pdf (20% success)
      <div class="answer">
        Long-Term Safety Evaluation of Ubrogepant for the AcuteTreatment of Migraine: Phase 3, Randomized, 52-WeekExtension Trial
        <!-- <textarea :rows="4" style="min-width:100px; max-width:100%; min-height:30px; height:100%; width:100%;"></textarea> -->
      </div>
    </div>
  </div>
</template>

<script>

import KeywordDataSource from '@/assets/data/Keyword2.json'

export default {
  name: 'ai-assistant',
  data () {
    return {
      askQuestion: false,
      keywordDataSource: KeywordDataSource,
      keywordColumns: [
        {
          title: '',
          headerAttributes: { class: 'grid-header-light' },
          columns: [
            { field: 'KeywordName', title: 'Keyword Name', headerAttributes: { class: 'grid-header-light' }, width: '120px' },
            { field: 'Type', title: 'Group', headerAttributes: { class: 'grid-header-light' } },
            { field: 'Aliases', title: 'Aliases', headerAttributes: { class: 'grid-header-light' }, width: '50px' },
            { field: 'Include', title: 'Include', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Include) { # checked # } #>' },
            { field: 'Exclude', title: 'Exclude', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Exclude) { # checked # } #>' },
            { field: 'Data', title: 'Data', headerAttributes: { class: 'grid-header-light' }, template: '<input type="checkbox" #if (Data) { # checked # } #>' },
            { field: 'Color', title: 'Color/Meaning', headerAttributes: { class: 'grid-header-light' }, template: '<div style="color: #:Color #;">#:Color #</div>' }
          ]
        }
      ]
    }
  },
  methods: {
    askQuestionAction: function () {
      this.askQuestion = true
    },
    cancelAction: function () {
      this.askQuestion = false
      this.$store.state.showAiAssistant = false
    }
  }
}
</script>

<style scoped>

  .answer {
    display:flex;
    flex-direction: row;
    background-color: #1b84db;
    color: rgb(255, 255, 255);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 10px;
  }
</style>
